export const TARGET_BLANK = '_blank';
export const TARGET_SELF = '_self';

export const ROUTE_PATHS = {
  PLANNER: '/planner',
  NEW_APPOINTMENT: '/planner/new-appointment',
  EDIT_APPOINTMENT: '/planner/edit-appointment',
  VIEW_APPOINTMENT: '/planner/view-appointment',
  WAIT_LIST_NEW_APPOINTMENT: '/planner/wait-list-new-appointment',
  CLIENT_AVAILABILITY: '/clients/',
  PROVIDER: '/providers/',
  PROVIDER_EDIT: '/staff/'
};

export const ROUTE_PARAMS = {
  CLIENT: '?client=',
  PROVIDER: '?provider=',
  EVENT: '?event=',
  WAITLIST_EVAL_TYPE: '&isDT=',
  WAITLIST_SUBTYPE: '&subType_Id=',
  WAITLIST_PARENT_TYPE: '&parentType_Id=',
  WAITLIST_NO_SESSIONS: '&Sessions=',
  WAITLIST_IS_ABA: '&isABA=',
  GUARANTEED_SHIFT_BI_RSS: '&guaranteedShiftBiRss=',
  CARE_CONNECT_PROVIDER: '&provider=',
  CARE_CONNECT_PARENT_TYPE_ID: '&parentType_Id=',
  CARE_CONNECT_START_TIME: '&startTime=',
  CARE_CONNECT_END_TIME: '&endTime=',
  CARE_CONNECT_LOCATION: '&location=',
  CARE_CONNECT_CLINIC: '&clinic=',
  CARE_CONNECT_RECURRING_EVERY: '&recurringEvery=',
  CARE_CONNECT_RECURRING_DAYS_ARRAY: '&recurringDaysArray=',
  PLANNER_VIEW: '&view='
};

export const SMART_SCHEDULE_URL = '/smart-schedule';
